import React from 'react';
import { Link } from 'react-router-dom';
import HorizontalScrollStrip from '../HorizontalScrollStrip';

/**
 * Editorial product shelf section — shared by featured, recently viewed, etc.
 */
export default function ProductShelfSection({
  eyebrow = '',
  title,
  lead = '',
  actionHref = '',
  actionLabel = '',
  layout = 'scroll',
  tone = 'default',
  className = '',
  ariaLabel = 'Products',
  children,
}) {
  const useGrid = layout === 'grid';

  const isExternalAction = /^https?:\/\//i.test(String(actionHref || ''));

  return (
    <section className={`product-shelf product-shelf--${tone} ${className}`.trim()}>
      <div className="product-shelf__band" aria-hidden="true" />
      <div className="container store-page__container product-shelf__container">
        <header className="product-shelf__head">
          <div className="product-shelf__head-copy">
            {eyebrow ? <p className="product-shelf__eyebrow">{eyebrow}</p> : null}
            <h2 className="product-shelf__title">{title}</h2>
            {lead ? <p className="product-shelf__lead">{lead}</p> : null}
          </div>
          {actionHref && actionLabel ? (
            isExternalAction ? (
              <a
                href={actionHref}
                className="product-shelf__action"
                target="_blank"
                rel="noopener noreferrer"
              >
                {actionLabel}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                  <path d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </a>
            ) : (
              <Link to={actionHref} className="product-shelf__action">
                {actionLabel}
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
                  <path d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </Link>
            )
          ) : null}
        </header>

        {useGrid ? (
          <div className="product-shelf__grid" aria-label={ariaLabel}>
            {children}
          </div>
        ) : (
          <HorizontalScrollStrip
            className="product-shelf__scroll-wrap"
            trackClassName="product-shelf__track"
            ariaLabel={ariaLabel}
          >
            {children}
          </HorizontalScrollStrip>
        )}
      </div>
    </section>
  );
}
